import settingService from '@/api/setting'
import { SETTINGS } from '../types'
import utils from '@/utils/utils.js'

export default {
  namespaced: true,
  state: {
    settings: {},
    tabSettings: {},
    siteConfig: {},
    unlimitedBookingsForUsersList: [],
    settingsColor: {}
  },
  getters: {
    settings (state) {
      return state.settings
    },
    siteConfig (state) {
      return state.siteConfig
    }
  },
  mutations: {
    [SETTINGS.SET_SETTINGS] (state, settings) {
      state.settings = settings
    },
    [SETTINGS.SET_SETTINGS_COLOR] (state, settingsColor) {
      state.settingsColor = settingsColor
    },
    [SETTINGS.SET_TAB_SETTINGS] (state, tabSettings) {
      state.tabSettings = tabSettings
    },
    [SETTINGS.SET_MINIMUM_BOOKING_INTERVAL] (state, settings) {
      state.settings.minimumBookingInterval = settings
    },
    [SETTINGS.SET_MAXIMUM_BOOKING_INTERVAL] (state, settings) {
      state.settings.maximumBookingInterval = settings
    },
    [SETTINGS.SET_COLOR_PRIMARY] (state, colorPrimary) {
      state.settingsColor.colorPrimary = colorPrimary
    },
    [SETTINGS.SET_COLOR_ACCENT] (state, colorAccent) {
      state.settingsColor.colorAccent = colorAccent
    },
    [SETTINGS.SET_SITE_SETTINGS] (state, settings){
      state.settings = settings
    },
    [SETTINGS.SET_SITE_CONFIG] (state, siteConfig){
      state.siteConfig = siteConfig
    },
    [SETTINGS.SELECT_USER] (state, item) {
      state.unlimitedBookingsForUsersList.push(item)
    },
    [SETTINGS.REMOVE_USER] (state, index) {
      state.unlimitedBookingsForUsersList.splice(index, 1)
    },
    [SETTINGS.SET_UNLIMITED_BOOKINGS_FOR_USERS] (state, users) {
      state.unlimitedBookingsForUsersList = users
    }
  },
  actions: {
    getSettings: function ({commit, dispatch}) {
      return new Promise((resolve, reject) => {
        settingService.getSettings().then((response) => {
          commit(SETTINGS.SET_SETTINGS, response.data)
          let unlimitedBookingsForUsers = []
          if (response.data.usersWithUnlimitedBooking) {
            unlimitedBookingsForUsers = response.data.usersWithUnlimitedBooking.map(userEmail => ({ email: userEmail}))
            dispatch('setUnlimitedBookingsForUsers', unlimitedBookingsForUsers)
          }
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getTabSettings: function ({commit}) {
      return new Promise((resolve, reject) => {
        settingService.getTabSettings().then((response) => {
          commit(SETTINGS.SET_TAB_SETTINGS, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getColorSettings: function ({commit, dispatch}) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {

        settingService.getColorSettings().then((response) => {
          commit(SETTINGS.SET_SETTINGS_COLOR, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, { root: true })
        })
      })
    },
    getSiteSettings: function ({commit, dispatch}, siteId) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        settingService.getSiteSettings(siteId).then((response) => {
          commit(SETTINGS.SET_SITE_SETTINGS, response.data)
          let unlimitedBookingsForUsers = []
          if (response.data.usersWithUnlimitedBooking) {
            unlimitedBookingsForUsers = response.data.usersWithUnlimitedBooking.map(userEmail => ({ email: userEmail}))
            dispatch('setUnlimitedBookingsForUsers', unlimitedBookingsForUsers)
          }
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, { root: true })
        })
      })
    },
    saveSiteSettings: function ({dispatch}, payload) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        settingService.saveSiteSettings(payload).then(() => {
          dispatch('Global/getInitialSettings', null, { root: true })
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, { root: true })
        })
      })
    },
    saveSettings: function ({dispatch}, payload) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        settingService.saveSettings(payload).then(() => {
          dispatch('Global/getInitialSettings', null, { root: true })
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, { root: true })
        })
      })
    },
    saveColorSettings: function ({dispatch}, payload) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        settingService.saveColorSettings(payload).then(() => {
          dispatch('Global/getInitialSettings', null, { root: true })
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, { root: true })
        })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    getLogo: function ({}) {
      return new Promise((resolve, reject) => {
        settingService.getLogo().then((response) => {
          resolve(utils.getImageFromApi(response))
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    saveLogo: function ({}, img) {
      return settingService.saveLogo(img)
    },
    setSettings ({ commit }, value) {
      commit(SETTINGS.SET_SETTINGS, value)
    },
    setColorPrimary ({ commit }, value) {
      commit(SETTINGS.SET_COLOR_PRIMARY, value)
    },
    setColorAccent ({ commit }, value) {
      commit(SETTINGS.SET_COLOR_ACCENT, value)
    },
    setSiteConfig ({ commit }, value) {
      commit(SETTINGS.SET_SITE_CONFIG, value)
    },
    setUnlimitedBookingsForUsers ({ commit }, users) {
      commit(SETTINGS.SET_UNLIMITED_BOOKINGS_FOR_USERS, users)
    },
    selectUnlimitedBookingsForUsers ({ commit }, item) {
      let user = item.email? {email: item.email, name: item.name} : {email: item}
      commit(SETTINGS.SELECT_USER, user)
    },
    resetSettings({ commit }){
      commit(SETTINGS.SET_SETTINGS, {})
    },
    removeUnlimitedBookingsForUsers ({ commit }, index) {
      commit(SETTINGS.REMOVE_USER, index)
    },
    resetUnlimitedBookingsForUsers ({ dispatch }) {
      dispatch('setUnlimitedBookingsForUsers', [])
    },
    resetInitialSettings({ commit }){
      commit(SETTINGS.SET_INITIAL_SETTINGS, {})
    },
    // eslint-disable-next-line no-empty-pattern
    async checkMeetProviderConnection ({}, keys) {
      try {
        return await settingService.checkMeetProviderConnection(keys)
      } catch (error) {
        return Promise.reject(error)
      }
    },
  }
}